import { render, staticRenderFns } from "./VINMVSList.vue?vue&type=template&id=71ecf42a&"
import script from "./VINMVSList.vue?vue&type=script&lang=js&"
export * from "./VINMVSList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports